// @ts-nocheck aa554af6
import * as addPanel from '#packages/oldAddPanel';

export default {
  getDesignSections() {
    return {
      titles: ['design_section_label_explore_contact'],
      sections: [addPanel.sections.getSections().contact.contactFormsSection],
    };
  },
};
